// extracted by mini-css-extract-plugin
module.exports = {"chip":"FilterChips-module_chip_1H59O","selected":"FilterChips-module_selected_1LX0a"};